import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiInputLabel = {
  defaultProps: {
    size: 'small', // Set the default size to 'small'
  },
  styleOverrides: {
    root: {
      // Additional custom styles can go here if needed
    },
  },
} satisfies Components<Theme>['MuiInputLabel'];
